<template>
  <div>
    <b-modal
      ref="modal-rrhh-discount-tracking"
      :title="$t('DISCOUNT TRACKING')"
      modal-class="modal-primary"
      hide-footer
      @hidden="$emit('hideModal')"
      size="lg"
      scrollable
    >
      <div class="mb-2 mt-1">
        <b-row>
          <!-- <b-col sm="6">
            <b-input-group class="mb-1">
              <template #prepend>
                <b-input-group-text class="prepend__width">
                  <strong>CODE</strong>
                </b-input-group-text>
              </template>
              <b-form-input :value="dataModal.code" disabled />
            </b-input-group>
          </b-col> -->
          <b-col lg="12">
            <b-input-group class="mb-1">
              <template #prepend>
                <b-input-group-text class="prepend__width">
                  <strong>NAME</strong>
                </b-input-group-text>
              </template>
              <b-form-input :value="modalData.full_name" disabled />
            </b-input-group>
          </b-col>
        </b-row>
      </div>
      <div class="table-responsive">
        <b-table
          small
          sticky-header="50vh"
          class="position-relative"
          table-class="text-nowrap"
          :items="items"
          :fields="fields"
        >
          <template #cell(created_by)="data">
            <span> {{ data.value }} </span><br />
            <span style="opacity: 0.7">
              {{ data.item.created_at | myGlobalDay }}
            </span>
          </template>
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="`light-${resolvStyleStatus(data.item.status)}`"
            >
              <span> {{ $t(data.value) }} </span>
            </b-badge>
          </template>
          <template #cell(description)="data">
            <span> {{ data.value | capitalize }} </span>
          </template>
          <template #cell(observation)="data">
            <span> {{ data.value }} </span>
          </template>
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* Service */
import DiscountService from "@/views/commons/discounts/services/discounts.service.js";

export default {
  props: {
    modalData: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: "created_by",
          label: this.$t("Created By"),
          visible: true,
        },
        {
          // [1]
          key: "status",
          label: this.$t("Status"),
          visible: true,
        },
        {
          // [1]
          key: "observation",
          label: this.$t("Observation"),
          visible: true,
        },
      ],
    };
  },
  mounted() {
    this.toggleModal("modal-rrhh-discount-tracking");
  },
  async created() {
    await this.getDiscountTraking();
  },
  computed: {
    showFields() {
      return this.fields.filter((item) => item.visible);
    },
  },
  methods: {
    async getDiscountTraking() {
      try {
        this.addPreloader();
        const params = {
          discount_id: this.modalData.discount_id,
        };

        const { data } = await DiscountService.getDiscount_tracking(params);
        this.items = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    resolvStyleStatus(status) {
      let val = "success";
      switch (status) {
        case "Pending":
          val = "warning";
          break;
        case "Approved":
          val = "info";
          break;
        case "Paid":
          val = "success";
          break;
        case "Anulled":
          val = "danger";
          break;
        default:
          break;
      }
      return val;
    },
  },
};
</script>

<style scoped>
.py-1s {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>